import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C, ModuleFE_Dialog, ModuleFE_Thunderstorm, TS_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { DropDown_ContextRule } from '../../../_entity/context-rule/ui-components.js';
import { ModuleFE_ContextRule } from '../../../_entity/context-rule/index.js';
import './Dialog_CompareRules.scss';
export class Dialog_CompareRules extends TS_Dialog {
    static defaultProps = {
        dialogId: 'rules-compare-dialog'
    };
    static show = () => {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_CompareRules, {})
        });
    };
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.rules ??= [];
        return state;
    }
    renderHeader = () => {
        return _jsx(_Fragment, { children: "Choose Rules To Compare" });
    };
    renderBody = () => {
        return _jsxs(LL_H_C, { className: 'rules-compare__dropdowns', children: [_jsx(DropDown_ContextRule.selectable, { selected: this.state.rules[0], onSelected: rule => this.setState({ rules: [rule._id, this.state.rules[1]] }) }), "vs", _jsx(DropDown_ContextRule.selectable, { selected: this.state.rules[1], onSelected: rule => this.setState({ rules: [this.state.rules[0], rule._id] }) })] });
    };
    buttons = () => ({
        right: [
            {
                content: 'Cancel',
                onClick: () => this.closeDialog(),
                variant: 'secondary'
            },
            {
                content: 'Compare',
                onClick: async () => {
                    const response = await ModuleFE_ContextRule._v1.compare({ ruleIds: this.state.rules }).executeSync();
                    ModuleFE_Thunderstorm.downloadFile({
                        url: response.excelSignedUrl,
                        fileName: response.fileName
                    });
                    this.closeDialog();
                },
                variant: 'primary'
            },
        ]
    });
}
//# sourceMappingURL=Dialog_CompareRules.js.map